(() => {
  'use strict';

  const ROOT = 'product-info[id^="MainProduct-"]';
  const STICKY_BUTTON = '.sticky-atc-trigger';
  const GLOBAL_FLAG = '__entrevoltasPdpCommerceLoaded';

  if (window[GLOBAL_FLAG]) return;
  window[GLOBAL_FLAG] = true;

  let sizeConfirmed = new URL(window.location.href).searchParams.has('variant');
  let scheduled = null;

  const normalize = (value) =>
    String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase('pt-BR');

  const parseStamp = (title) => {
    const value = String(title || '').trim();
    const match = value.match(/\s+(?:—|–|-)\s+/);
    if (!match || match.index == null) return value;
    return value.slice(match.index + match[0].length).trim() || value;
  };

  const root = () => document.querySelector(ROOT);

  const sizeFieldset = () => {
    const productRoot = root();
    if (!productRoot) return null;

    return Array.from(productRoot.querySelectorAll('variant-selects fieldset')).find((fieldset) => {
      const label =
        fieldset.querySelector('legend')?.textContent ||
        fieldset.querySelector('.form__label')?.textContent ||
        '';
      const key = normalize(label);
      return key.includes('tamanho') || key.includes('size');
    }) || null;
  };

  const mainButton = () => root()?.querySelector('[id^="ProductSubmitButton-"]') || null;

  const stickyButtons = () => Array.from(root()?.querySelectorAll(STICKY_BUTTON) || []);

  const updateSticky = () => {
    const productRoot = root();
    if (!productRoot) return;

    const size = sizeFieldset();
    const primary = mainButton();
    const title = productRoot.querySelector('.product__title h1')?.textContent || '';
    const stamp = parseStamp(title);
    const stickyTitle = productRoot.querySelector('.sticky-atc-title-mobile');

    if (stickyTitle && stickyTitle.textContent.trim() !== stamp) {
      stickyTitle.textContent = stamp;
    }

    stickyButtons().forEach((button) => {
      const span = button.querySelector('span');
      const mustChooseSize = Boolean(size && !sizeConfirmed);

      if (mustChooseSize) {
        button.disabled = false;
        button.setAttribute('aria-label', 'Escolher tamanho');
        if (span && span.textContent.trim() !== 'Escolher tamanho') span.textContent = 'Escolher tamanho';
        return;
      }

      if (primary) {
        button.disabled = primary.disabled;
        const label = primary.querySelector('span')?.textContent?.trim() || 'Adicionar à sacola';
        button.setAttribute('aria-label', label);
        if (span && span.textContent.trim() !== label) span.textContent = label;
      }
    });
  };

  const scheduleUpdate = () => {
    if (scheduled) window.clearTimeout(scheduled);
    scheduled = window.setTimeout(() => {
      scheduled = null;
      updateSticky();
    }, 100);
  };

  const scrollToSize = () => {
    const size = sizeFieldset();
    if (!size) return false;

    size.classList.add('ev-pdp-size-attention');
    size.scrollIntoView({ behavior: 'smooth', block: 'center' });

    window.setTimeout(() => size.classList.remove('ev-pdp-size-attention'), 1000);
    return true;
  };

  // Capture before the theme's delegated sticky ATC handler.
  document.addEventListener('click', (event) => {
    const button = event.target.closest(STICKY_BUTTON);
    if (!button || window.innerWidth >= 750) return;

    const size = sizeFieldset();
    if (size && !sizeConfirmed) {
      event.preventDefault();
      event.stopImmediatePropagation();
      scrollToSize();
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects')) return;

    const fieldset = event.target.closest('fieldset');
    if (fieldset) {
      const label =
        fieldset.querySelector('legend')?.textContent ||
        fieldset.querySelector('.form__label')?.textContent ||
        '';
      const key = normalize(label);

      if (key.includes('tamanho') || key.includes('size')) {
        sizeConfirmed = true;
      }
    }

    scheduleUpdate();
  }, true);

  document.addEventListener('variant:change', scheduleUpdate);

  const init = () => {
    const productRoot = root();
    if (!productRoot) return;

    updateSticky();

    const sticky = productRoot.querySelector('.sticky-atc');
    if (sticky && !sticky.dataset.evPdpObserved) {
      sticky.dataset.evPdpObserved = 'true';

      const observer = new MutationObserver(() => scheduleUpdate());
      observer.observe(sticky, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
